<div class="bg-white">
    <div class="px-4 py-3" style="background-color:#EDF4FB">
        <h5 class="font-weight-bold">Beneficiary Details - {{ beneficiaryData['firstAndLastName'] }} </h5>
    </div>

  <div class="border">
    <div class="row">
      <div class="m-4 card p-0 w-100">

                  <div class="row px-4">
                      <div class="col-12 mb-2">
                          <h5 class="labelText mt-2">Personal Details</h5>

                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Name</p>
                          <label class="label-dark">{{ beneficiaryData['firstAndLastName'] ? beneficiaryData['firstAndLastName'] : "--"}}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Age</p>
                          <label class="label-dark">{{ beneficiaryData['firstAndLastName'] ? beneficiaryData['firstAndLastName'] : "--"}}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Gender</p>
                          <label class="label-dark">{{ beneficiaryData['gender'] ? beneficiaryData['gender'].name : "--"}}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Citizenship</p>
                          <label class="label-dark">{{ beneficiaryData?.ctznshipCountryCode?.countryName ? beneficiaryData?.ctznshipCountryCode?.countryName : "--" }}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Country</p>
                          <label class="label-dark">{{ beneficiaryData?.phoneContacts[0]?.countryCode?.countryCode ? beneficiaryData?.phoneContacts[0]?.countryCode?.countryCode : "--" }}</label>
                      </div>
                  </div>
                  <div class="row px-4">
                      <div class="col-12">
                          <hr class="dashed-border">
                      </div>
                  </div>
                  <div class="row px-4">
                      <div class="col-12 mb-2">
                          <h5 class="labelText mt-2">Address</h5>

                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Address 1</p>
                          <label class="label-dark">{{
                            beneficiaryData?.address[0]?.addressLine1
                              ? beneficiaryData?.address[0]?.addressLine1
                              : "--"
                          }}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Address 2</p>
                          <label class="label-dark">{{
                            beneficiaryData?.address[0]?.addressLine2
                              ? beneficiaryData?.address[0]?.addressLine2
                              : "--"
                          }}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">City</p>
                          <label class="label-dark">{{
                            beneficiaryData?.address[0]?.city
                              ? beneficiaryData?.address[0]?.city
                              : "--"
                          }}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Country</p>
                          <label class="label-dark">{{
                            beneficiaryData?.address[0]?.countryCode?.countryName
                              ? beneficiaryData?.address[0]?.countryCode?.countryName
                              : "--"
                          }}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">State</p>
                          <label class="label-dark" *ngIf="listStatesCurrent.length > 0">{{
                            beneficiaryData?.address[0]?.stateProvinceCode
                              ? getStateName(
                                  beneficiaryData.address[0]?.stateProvinceCode,
                                  "Current"
                                )
                              : "--"
                          }}</label>
                          <label class="label-dark" *ngIf='listStatesCurrent.length <= 0'> {{
                            beneficiaryData?.address[0]?.stateProvinceName
                              ? beneficiaryData?.address[0]?.stateProvinceName
                              : "--"
                          }}</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Location</p>
                          <label class="label-dark">test1</label>
                      </div>
                  </div>
                  <div class="row px-4">
                      <div class="col-12">
                          <hr class="dashed-border">
                      </div>
                  </div>
                  <div class="row px-4">
                      <div class="col-12 mb-2">
                          <h5 class="labelText mt-2">Education</h5>

                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Degree</p>
                          <label class="label-dark">test1</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">University</p>
                          <label class="label-dark">test1</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Field of Study</p>
                          <label class="label-dark">test1</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">Started Year</p>
                          <label class="label-dark">test1</label>
                      </div>
                      <div class="col mb-2">
                          <p class="label-light m-0">End Year</p>
                          <label class="label-dark">test1</label>
                      </div>
                  </div>


      </div>
  </div>
  </div>
</div>
